import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import globals from '../../globals/globals';
import { execute } from '../../native-app-bridge/native-app-bridge';
import browserNavigation from './browser-navigation';
export default (function (navigation) {
  var result;

  if (globals().nativeWrapped) {
    var navigationItem = navigation.navigationItem;
    var payload = {
      docType: 'pdf',
      url: navigationItem.url,
      enableZoom: true
    };
    execute('openDocument', payload);
    result = Promise.resolve();
  } else {
    result = browserNavigation(navigation);
  }

  return result;
});